import { REPORT_RIBBON_CHANGE_EVENT } from './constants'

export function reportRibbonOnChange() {
    return {
        type: REPORT_RIBBON_CHANGE_EVENT,
    }
}
